"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultShareQuizzesWithTeachersEventMessage = void 0;
exports.defaultShareQuizzesWithTeachersEventMessage = {
    version: 1,
    eventType: 'shareQuizzesWithTeachers',
    headers: {
        correlationid: undefined
    },
    body: {
        sharingTeacherId: undefined,
        teacherData: undefined,
        quizId: undefined,
        timeCreated: undefined
    }
};
//# sourceMappingURL=shareQuizzesWithTeachers.js.map